
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "flowSteps"
})
export default class flowSteps extends BaseVue {
  @Prop({ default: () => [] }) data!: any; // 工具栏列表
  current=0    //当前高亮第几步
  pageEleId=this.NewGuid()    //组件元素id
  pageWidth:any=0             //组件宽度（单位:px）
  @Watch("data",{deep:true})
  dataChange(){
    if(this.data.length>0){
      this.refreshSign()
    }
  }
  mounted() {
    setTimeout(()=>{
      this.pageWidth = $("#"+this.pageEleId).width()
    },300)
    if(this.data.length>0){
      this.refreshSign()
    }      
  }

  refreshSign(){
    setTimeout(() => {
      this.data.forEach((item,index) => {
				if(item.Status == 2||item.Status == 9)
				{
					this.current = index;
          this.$emit('currentChange', item);
				}  
        item.signData.forEach((item2,index2) => {
          let signTag = ""
          let signCanvasId = ""
          if(item2.sign){
            signCanvasId = 'flow_step_sign_'+item2.Id
            signTag = "sign"
          }else if(item2.signature){
            signCanvasId = 'flow_step_signature_'+item2.Id
            signTag = "signature"
          }else{
            return
          }
          let canvas1:any = document.getElementById(signCanvasId)
          var canvasW:any = $("#"+signCanvasId).width()
          var canvasH:any = $("#"+signCanvasId).height()
          let ctx = canvas1.getContext('2d')
          var img = new Image();
          img.onload = function(){ 
            ctx.drawImage(img,0,0,img.width*canvasH/img.height,canvasH);
            // state=2为无效签名,开始绘制划线
            if(item2.state==2){
              ctx.beginPath();
              ctx.lineCap="round";
              ctx.lineWidth=5;
              ctx.strokeStyle="#808080";
              ctx.moveTo(10,canvasH/2 - 5);
              ctx.lineTo(130,canvasH/2 - 5);
              ctx.moveTo(10,canvasH/2 + 5);
              ctx.lineTo(130,canvasH/2 + 5);
              ctx.stroke();
            }
          } 
          img.src = item2[signTag];
        });
      })   
      
      if(this.current == 0 && this.data.filter(d=>d.Status == 3).length == this.data.length) {
        this.current = this.data.length - 1;
      }
    }, 500);
  }
  onPopperToggle(toggle,signInfo){
    this.$emit("on-popper-toggle",toggle,signInfo)
  }
}
